import type { MapEventBus } from "../../core/MapEventBus";

export class PrimitivesSelection {
  private selectedTarget = new Set<string>();

  constructor(private eventBus: MapEventBus) {
    this.setupListeners();
  }

  private setupListeners() {
    // Listen to click events
    this.eventBus.on("primitive:clicked", ({ primitive_id }) => {
      this.toggle(primitive_id);
    });
  }

  private toggle(primitive_id: string) {
    if (this.selectedTarget.has(primitive_id)) {
      // Same primitive - deselect
      this.deselect(primitive_id);
    } else {
      // Different primitive - select
      this.select(primitive_id);
    }
  }

  private select(primitive_id: string) {
    this.selectedTarget.add(primitive_id);
    this.eventBus.emit("primitive:selected", { primitive_id });
  }

  private deselect(primitive_id: string) {
    if (!this.selectedTarget) return;
    this.selectedTarget.delete(primitive_id);
    console.log("[PrimitivesSelection] Deselected:", primitive_id);
    this.eventBus.emit("primitive:deselected", { primitive_id });
  }

  // Public API
  getSelected(): string[] | null {
    return Array.from(this.selectedTarget.values());
  }

  isSelected(primitive_id: string): boolean {
    return this.selectedTarget.has(primitive_id);
  }

  // Programmatic control
  selectPrimitive(primitive_id: string) {
    if (!this.selectedTarget.has(primitive_id)) {
      this.select(primitive_id);
    }
  }

  deselectPrimitive(primitive_id: string) {
    this.deselect(primitive_id);
  }

  togglePrimitive(primitive_id: string) {
    this.toggle(primitive_id);
  }

  destroy() {
    this.selectedTarget.clear();
  }
}
